import { render, staticRenderFns } from "./CmpAddAuthority.vue?vue&type=template&id=5d4d7fbe&scoped=true&"
import script from "./CmpAddAuthority.vue?vue&type=script&lang=js&"
export * from "./CmpAddAuthority.vue?vue&type=script&lang=js&"
import style0 from "./CmpAddAuthority.vue?vue&type=style&index=0&id=5d4d7fbe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4d7fbe",
  null
  
)

export default component.exports